var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 20,
    viewBox: "0 0 49 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5961_23128)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4609 10.2763C48.4609 6.87729 46.7917 4.19531 43.6012 4.19531C40.3974 4.19531 38.459 6.87729 38.459 10.2497C38.459 14.2461 40.7474 16.2642 44.032 16.2642C45.634 16.2642 46.8455 15.9057 47.7608 15.4012V12.7458C46.8455 13.1973 45.7955 13.476 44.4628 13.476C43.157 13.476 41.9993 13.0246 41.8513 11.4579H48.434C48.434 11.2853 48.4609 10.5949 48.4609 10.2763ZM41.8108 9.01491C41.8108 7.51459 42.7397 6.89057 43.5877 6.89057C44.4089 6.89057 45.284 7.51459 45.284 9.01491H41.8108Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2632 4.19531C31.944 4.19531 31.0959 4.80606 30.6249 5.23093L30.4498 4.40774H27.4883V19.8889L30.8536 19.1852L30.8672 15.4278C31.3517 15.7729 32.0652 16.2642 33.2498 16.2642C35.6594 16.2642 37.8537 14.3523 37.8537 10.1435C37.8402 6.2931 35.619 4.19531 33.2632 4.19531ZM32.4556 13.3432C31.6614 13.3432 31.1902 13.0644 30.8672 12.7192L30.8536 7.79341C31.2036 7.40838 31.6883 7.14284 32.4556 7.14284C33.6806 7.14284 34.5286 8.4971 34.5286 10.2364C34.5286 12.0155 33.6941 13.3432 32.4556 13.3432Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8574 3.41222L26.2363 2.69526V0L22.8574 0.703689V3.41222Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2363 4.4209H22.8574V16.0383H26.2363V4.4209Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2364 5.40344L19.021 4.42093H16.1133V16.0385H19.4786V8.16508C20.2729 7.14274 21.619 7.32863 22.0364 7.47468V4.42093C21.6055 4.26161 20.0306 3.96951 19.2364 5.40344Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5052 1.54004L9.22049 2.23045L9.20703 12.8654C9.20703 14.8305 10.7012 16.2776 12.6936 16.2776C13.7974 16.2776 14.6051 16.0785 15.0494 15.8396V13.1442C14.6186 13.3169 12.4916 13.9276 12.4916 11.9626V7.24921H15.0494V4.42118H12.4916L12.5052 1.54004Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40577 7.79342C3.40577 7.27561 3.83654 7.07646 4.55 7.07646C5.57308 7.07646 6.86539 7.38183 7.88847 7.92619V4.80606C6.77115 4.36791 5.66731 4.19531 4.55 4.19531C1.81731 4.19531 0 5.60269 0 7.95275C0 11.6172 5.11538 11.0331 5.11538 12.613C5.11538 13.2238 4.57693 13.4229 3.82308 13.4229C2.70577 13.4229 1.27885 12.9715 0.148077 12.3608V15.5207C1.4 16.0518 2.66539 16.2775 3.82308 16.2775C6.62308 16.2775 8.54808 14.9099 8.54808 12.5333C8.53462 8.57677 3.40577 9.28046 3.40577 7.79342Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5961_23128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.3978,
    height: 19.8895,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.4397d3189c42ef019de56afc57944864.svg";
export { ForwardRef as ReactComponent };